/** @internal */ export const DEFAULT_CERAMIC_NETWORK = 'testnet-clay';
/** @internal */ export const DEFAULT_CONNECT_NETWORK = 'testnet-clay';
/** @internal */ export const VIEWER_ID_STORAGE_KEY = 'self.id-local-id';
